import { TResponseOrderDetails } from "@/types/projectType";
import TableRow from "./ordersTable/TableRow";
import { TCreatorProjectResponseType, TFilterOptions } from "../Projects";

type OrderTableViewProps = {
  data: TCreatorProjectResponseType[];
};

const tableTitles = [
  "Project name",
  "Client",
  "Videos",
  "Due in",
  // "Stage",
  "Status",
  "Actions",
];

const ProjectTableView = ({ data }: OrderTableViewProps) => {
  return (
    <div className="hidden overflow-auto md:block rounded-xl border-[1.5px] border-[#D0D5DD]">
      <table className="w-full">
        <thead className="bg-[#737B950D]">
          <tr className="border-[#D0D5DD] border-b">
            {tableTitles.map((title, index) => (
              <th
                key={index}
                className="text-base  font-medium text-[#97979B] text-start py-5 px-3 whitespace-nowrap"
              >
                {title}
              </th>
            ))}
          </tr>
        </thead>

        {data?.length === 0 ? (
          <tbody>
            <tr>
              <td colSpan={tableTitles.length} className="p-0">
                <div className="w-full flex justify-center items-center   h-40">
                  <p className="font-semibold text-center text-gray-600 text-lg">
                    No Data
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        ) : (
          <tbody>
            {data?.map((item, index) => (
              <TableRow item={item} index={index} key={index} />
            ))}
          </tbody>
        )}
      </table>
    </div>
  );
};

export default ProjectTableView;
